/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { IconButton, Stack, Typography } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

type PagePaginationProps = {
  currentPage: number;
  totalPages: number;
  handlePrevPage: ()=> void;
  handleNextPage: ()=> void;
}

export default function PagePagination({ currentPage, totalPages, handlePrevPage, handleNextPage }: PagePaginationProps) {
  return (
    <Stack
      direction={"row"}
      sx={{
        alignItems: "center",
        columnGap: "16px",
        padding: "16px"
      }}>
      <IconButton onClick={handlePrevPage} disabled={currentPage <= 1}>
        <ChevronLeft />
      </IconButton>
      <Typography>
        {currentPage} - {totalPages}
      </Typography>
      <IconButton onClick={handleNextPage} disabled={currentPage >= totalPages}>
        <ChevronRight />
      </IconButton>
    </Stack>
  );
}
